/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".image-container[_ngcontent-%COMP%]{padding:16px;position:absolute;width:100%;top:50%;-webkit-transform:translateY(-50%);transform:translateY(-50%);border-radius:16px;max-height:100%;overflow:auto}.image-container[_ngcontent-%COMP%]   .img-box[_ngcontent-%COMP%]{background:#fff}.image-container[_ngcontent-%COMP%]   .btn-box[_ngcontent-%COMP%]{text-align:center}"];
export { styles as styles };
